import { useCallback, useContext, useEffect, useState } from "react"
import { useDispatch } from "react-redux"
import { BsReply } from "react-icons/bs"
import { TiArrowForwardOutline } from "react-icons/ti"
import { FaCircleArrowRight } from "react-icons/fa6";

import { useLocation } from "react-router-dom/cjs/react-router-dom"
import { Loader } from "rsuite";
import { getEmailListForUser } from "../../../../../redux/actions/emailSettings";
import { toast } from "../../../../CommonComponents/ToastComponent/toast";
import { getEmailDetailsByConversationId } from "../../../../../redux/actions/notification";
import { AppContext } from "../../../../../context";
import Title from "../../../../CommonComponents/Title";
import { colors } from "../../../../../utils/constants/colors";
import { formatRelativeDate } from "../../../../../services/helper";
import ComposeEmail from "../../../../ComposeEmail";
import ModalComponent from "../../../../CommonComponents/Modal";

const EmailDetail = ({ currentTab, tab, subTab, selectedNotification, currentPage, setCurrentPage }) => {
    let dispatch = useDispatch()
    const location = useLocation()
    const queryParams = location.search?.split('&')

    let paramDomain = queryParams[0]?.split('=')[1]
    let paramEmailChainId = queryParams[1]?.split('=')[1]
    let paramRegisteredEmail = queryParams[2]?.split('=')[1]

    const { convertEmailHistoryStructure } = useContext(AppContext);
    const [hoveredIndex, setHoveredIndex] = useState(null);
    const [selectedConversationId, setSelectedConversationId] = useState(null)
    const [selectedConversation, setSelectedConversation] = useState(null)
    const [detailLoader, setDetailLoader] = useState(false)
    const [conversationEmails, setConversationEmails] = useState([])
    const [showComposeEmailBox, setShowComposeEmailBox] = useState(false)
    const [actionOnEmailForTask, setActionOnEmailForTask] = useState(null)

    const getRegisteredEmail = useCallback(async (paramDomain, paramEmailChainId, paramRegisteredEmail) => {
        let tmpConversationEmails = []
        let formattedEmailConversation = []
        let sortedEmails = []
        setDetailLoader(true)

        const registeredEmails = await dispatch((getEmailListForUser())).then((res) => res).catch((err) => {
            if (err) {
                toast.show({
                    title: 'Danger',
                    description: 'Error Occured While Fetching User Emails',
                })
            }

            return []
        })

        if (registeredEmails?.length > 0) {
            let targetedEmail = registeredEmails?.filter((registeredEmail) => registeredEmail?.email === paramRegisteredEmail)
            if (targetedEmail?.length > 0) {
                tmpConversationEmails = await dispatch(getEmailDetailsByConversationId(targetedEmail?.[0]?.accessToken, targetedEmail?.[0]?.email, paramEmailChainId, targetedEmail?.[0]?.refreshToken, paramDomain)).then(res => res?.conversation).catch((err) => {
                    if (err) {
                        toast.show({
                            title: 'Danger',
                            description: 'Error Occured While Fetching Old Conversation',
                        })
                    }
                    return []
                })

                if (paramDomain === 'google') {
                    formattedEmailConversation = tmpConversationEmails?.map((tmpConversationEmail) => {
                        let formatedEmail = convertEmailHistoryStructure(paramDomain, null, tmpConversationEmail, targetedEmail)
                        return formatedEmail
                    })
                } else {
                    formattedEmailConversation = tmpConversationEmails?.map((tmpConversationEmail) => {
                        let formatedEmail = convertEmailHistoryStructure(paramDomain, null, tmpConversationEmail, targetedEmail)
                        return formatedEmail
                    })
                }


                sortedEmails = formattedEmailConversation?.sort((a, b) => {
                    return new Date(b.receivedDate) - new Date(a.receivedDate);
                });
                setDetailLoader(false)
                setSelectedConversationId(sortedEmails[0]?.messageId)
                setSelectedConversation(sortedEmails[0])
                setConversationEmails(sortedEmails)
            }
        } else {
            setDetailLoader(false)
            setSelectedConversationId(null)
            setSelectedConversation(null)
            setConversationEmails([])
        }
    }, [])

    const onReplyEmail = () => {
        setActionOnEmailForTask('reply')
        setShowComposeEmailBox(true)
    }

    const onForwardEmail = () => {
        setActionOnEmailForTask('forward')
        setShowComposeEmailBox(true)
    }

    const onOldConversationSelected = (messageId) => {
        setSelectedConversationId(messageId)
        let tmpSelectedConversation = conversationEmails?.filter(conversationEmail => conversationEmail?.messageId === messageId)[0]
        setSelectedConversation(tmpSelectedConversation)
    }

    const composeEmailCloseHandler = () => {
        setShowComposeEmailBox(false)
    }

    useEffect(() => {
        getRegisteredEmail(paramDomain, paramEmailChainId, paramRegisteredEmail)
    }, [])

    return (
        <div className="container-fluid h-100 d-flex p-0 column-gap-3" style={{ borderRadius: '6px' }}>
            <div className="col-3 notification-sidebar h-100">
                {
                    showComposeEmailBox && (<ModalComponent size='md' modalTitle='' open={showComposeEmailBox} handleClose={composeEmailCloseHandler} dialogClassName='px-5 create-new-contact-modal-dialog'>
                        <ComposeEmail
                            componentFor={'notificationDetail'}
                            supplierInfo={{}}
                            vendorInfo={{}}
                            contactOptions={[]}
                            onGetExistingContacts={() => { }}
                            vendorInCallDetailsId={null}
                            contacts={[]}
                            getContactsData={() => { }}
                            activeTab={''}
                            actionOnEmailForTask={actionOnEmailForTask}
                            selectedEmail={selectedConversation} //selectedEmail
                            selectedFormatedEmail={selectedConversation}
                            domain={selectedConversation?.domain} //selectedMailAndCategory?.domain
                            setShowComposeEmailBox={setShowComposeEmailBox}
                            composeEmailCloseHandler={composeEmailCloseHandler}
                            setShow={setShowComposeEmailBox}
                        />
                    </ModalComponent>)
                }
                {<>
                    <h3 className="fw-bold" style={{ color: colors.blue800 }}>Conversation History</h3>
                    {detailLoader ? <div className="d-flex justify-content-center align-items-center" style={{ height: "90%" }}>
                        <Loader />
                    </div> : <div className="no-scrollbar mt-5" style={{ overflowY: 'scroll', height: '90%' }}>
                        {
                            conversationEmails?.map((conversationEmail) => {
                                return (
                                    <div
                                        key={conversationEmail?.messageId}
                                        className="border mb-3 p-3 conversation-item d-flex justify-content-between"
                                        style={{
                                            borderRadius: '6px',
                                            backgroundColor: (hoveredIndex === conversationEmail?.messageId || selectedConversationId === conversationEmail?.messageId) ? 'white' : colors.grey200,
                                            color: (hoveredIndex === conversationEmail?.messageId || selectedConversationId === conversationEmail?.messageId) ? '#214466' : colors.blue800,
                                            cursor: 'pointer'
                                        }}
                                        onMouseEnter={() => setHoveredIndex(conversationEmail?.messageId)}
                                        onMouseLeave={() => setHoveredIndex(null)}
                                        onClick={() => { onOldConversationSelected(conversationEmail?.messageId) }}
                                    >
                                        <div>
                                            <h3 className="m-0 fw-bolder">{conversationEmail?.subject}</h3>
                                            <p className="fs-4 mt-2">{conversationEmail?.body?.slice(0, 30) + '...'}</p>
                                            <p className="mt-1 fs-4">{formatRelativeDate(selectedConversation?.receivedDate || '')}</p>
                                        </div>
                                        {selectedConversationId === conversationEmail?.messageId && <div className="d-flex align-items-center">
                                            <FaCircleArrowRight color={colors.blue800} size={25} />
                                        </div>}
                                    </div>
                                )
                            })
                        }
                    </div>}
                </>
                }
            </div>
            {detailLoader ? <div className="d-flex justify-content-center align-items-center w-100">
                <Loader />
            </div> : <div className="col-8 border py-3 px-5 h-100">
                <Title title={selectedConversation?.subject} />
                <div className="d-flex mt-4 align-items-center">
                    <button className=" btn btn-lg rounded-circle" style={{ backgroundColor: '#d9d9d9', width: 45, height: 45 }}></button>
                    <div className="mx-4">
                        <p className="fw-bold fs-4 m-0 text-black">{selectedConversation?.senderName}</p>
                        <p className="fs-4 m-0 text-black">{selectedConversation?.senderEmail}</p>
                    </div>
                </div>
                <div className="h-75  mt-5">
                    <h3 className="text-center">{selectedConversation?.subject}</h3>
                    <div className=" mt-4 d-flex align-items-center flex-column no-scrollbar" style={{ height: '70%', overflowY: 'scroll' }}>
                        <div
                            dangerouslySetInnerHTML={{
                                __html: selectedConversation?.mainBody
                            }}
                            className='mt-3 fs-4 rounded'
                        >
                        </div>
                    </div>
                </div>

                <div className="d-flex column-gap-3 mt-4 ">
                    <button className="report_button_success" onClick={onReplyEmail}><BsReply size={20} className="mx-2" style={{ verticalAlign: 'top' }} />Reply</button>
                    <button className="report_button_success" onClick={onForwardEmail}><TiArrowForwardOutline size={20} className="mx-2 p" style={{ verticalAlign: 'top' }} />Forward</button>
                </div>
            </div>}
        </div>
    )
}

export default EmailDetail